import React from 'react';
import { PictureGallery } from '../../components';
import { useProperty } from '../../hooks/useProperty';
import { useSteps } from '../../hooks/useSteps';
import { Helmet } from 'react-helmet';
import BackForwardButtons from '../../components/buttons/BackForwardButtons';

export default function PropertyPhotoPage() {
  const { propertyData } = useProperty();

  const projectType = propertyData?.projectType;
  const { prev, next } = useSteps(projectType);

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Property Gallery</title>
      </Helmet>

      <div className="w-full mt-14"></div>

      <PictureGallery />

      <div className="flex justify-between mt-7">
        <BackForwardButtons prev={prev} next={next} />
      </div>
    </>
  );
}
